<template>
  <teleport to="#notifications">
    <div class="fixed inset-x-0 bottom-0">
      <div
        :class="{
          'bg-green-600': style == 'success',
          'bg-red-700': style == 'danger',
        }"
      >
        <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
          <div class="flex items-center justify-between flex-wrap">
            <div class="w-0 flex-1 flex items-center">
              <span
                class="flex p-2 rounded-lg"
                :class="{
                  'bg-green-700': style == 'success',
                  'bg-red-600': style == 'danger',
                }"
              >
                <CheckCircleIcon
                  v-if="style == 'success'"
                  class="h-6 w-6 text-white"
                />

                <ExclamationIcon
                  v-if="style == 'danger'"
                  class="h-6 w-6 text-white"
                />
              </span>
              <p class="ml-3 text-sm font-medium text-white truncate">
                {{ message }}
              </p>
            </div>
            <div class="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
              <button
                @click.prevent="$emit('close')"
                type="button"
                :class="{
                  'hover:bg-green-700 focus:bg-green-700': style == 'success',
                  'hover:bg-red-600 focus:bg-red-600': style == 'danger',
                }"
                class="-mr-1 flex p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2"
              >
                <XIcon class="h-6 w-6 text-white" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import {
  CheckCircleIcon,
  ExclamationIcon,
  XIcon,
} from "@heroicons/vue/outline";

export default {
  emits: ["close"],

  components: {
    CheckCircleIcon,
    ExclamationIcon,
    XIcon,
  },

  props: ["message", "style"],

  mounted() {
    setTimeout(() => {
      this.$emit("close");
    }, 5000);
  },
};
</script>
